/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {domContentLoadedFactory as Éµnguniversal_modules_common_common_a} from './src/state-transfer-initializer/module';